// 工具类方法集
/**
 * 解析时间字符串
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if (typeof time === 'string') {
			if (/^[0-9]+$/.test(time)) {
				// support "1548221490638"
				date = parseInt(time)
			} else {
				// support safari
				// https://stackoverflow.com/questions/4310953/invalid-date-in-safari
				date = time.replace(new RegExp(/-/gm), '/')
			}
		}

		if (typeof time === 'number' && time.toString().length === 10) {
			date = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}

	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
	let date
	if (('' + time).length === 10) {
		date = parseInt(time) * 1000
	} else {
		date = +time
	}
	const d = new Date(date)
	const now = Date.now()

	const diff = (now - d) / 1000

	if (diff < 30) {
		return '刚刚'
	} else if (diff < 3600) {
		// less 1 hour
		return Math.ceil(diff / 60) + '分钟前'
	} else if (diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前'
	} else if (diff < 3600 * 24 * 2) {
		return '1天前'
	}
	if (option) {
		return parseTime(time, option)
	} else {
		return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
	}
}

//日期格式化
export function formatDate(date) {
	if (!date) return ''
	const d = new Date(date)
	let month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear()

	if (month.length < 2) {
		month = '0' + month
	}
	if (day.length < 2) {
		day = '0' + day
	}

	return [year, month, day].join('-')
}

/**
 * 参数转换
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
	const search = url.split('?')[1]
	if (!search) {
		return {}
	}
	return JSON.parse(
		'{"' +
			decodeURIComponent(search)
				.replace(/"/g, '\\"')
				.replace(/&/g, '","')
				.replace(/=/g, '":"')
				.replace(/\+/g, ' ') +
			'"}'
	)
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
		const value = params[propName]
		var part = encodeURIComponent(propName) + '='
		if (value !== null && typeof value !== 'undefined') {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && typeof value[key] !== 'undefined') {
						const params = propName + '[' + key + ']'
						var subPart = encodeURIComponent(params) + '='
						result += subPart + encodeURIComponent(value[key]) + '&'
					}
				}
			} else {
				result += part + encodeURIComponent(value) + '&'
			}
		}
	}
	return result
}

/**
 * 深拷贝（适用于数组和对象）
 * @param obj
 * @returns {*[]}
 */
export function deepClone(obj) {
	const objClone = Array.isArray(obj) ? [] : {}
	if (obj && typeof obj === 'object') {
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				//判断ojb子元素是否为对象，如果是，递归复制
				if (obj[key] && typeof obj[key] === 'object') {
					objClone[key] = deepClone(obj[key])
				} else {
					//如果不是，简单复制
					objClone[key] = obj[key]
				}
			}
		}
	}
	return objClone
}

/**
 * 数组去重
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
	return Array.from(new Set(arr))
}

/**
 * 生成唯一且随机的字符串
 * @returns {string}
 */
export function createUniqueString() {
	const timestamp = +new Date() + ''
	const randomNum = parseInt((1 + Math.random()) * 65536) + ''
	return (+(randomNum + timestamp)).toString(32)
}

/**
 * 生成16位随机id
 * @param n 代表位数，生成多少位
 * @returns {string}
 */
export function creatRandomId(n = 16) {
	var str = [
		'0',
		'1',
		'2',
		'3',
		'4',
		'5',
		'6',
		'7',
		'8',
		'9',
		'A',
		'B',
		'C',
		'D',
		'E',
		'F',
		'G',
		'H',
		'I',
		'J',
		'K',
		'L',
		'M',
		'N',
		'O',
		'P',
		'Q',
		'R',
		'S',
		'T',
		'U',
		'V',
		'W',
		'X',
		'Y',
		'Z'
	]
	var res = ''
	for (let i = 0; i < n; i++) {
		const id = Math.ceil(Math.random() * 35)
		res += str[id]
	}
	return res
}

/**
 * 生成 UUID
 * @returns {string}
 */
export function createUuid() {
	let d = new Date().getTime()
	if (window.performance && typeof window.performance.now === 'function') {
		d += performance.now() // 如果可用，请使用高精度计时器
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = (d + Math.random() * 16) % 16 | 0
		d = Math.floor(d / 16)
		return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
	})
}

/**
 * 生成 UUID
 * @returns {string}
 */
export function getUuid() {
	return createUuid().replaceAll('-', '')
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id = 'id', parentId = 'parentId', children = 'children') {
	const config = {
		id: id || 'id',
		parentId: parentId || 'parentId',
		childrenList: children || 'children'
	}

	var childrenListMap = {}
	var nodeIds = {}
	var tree = []

	for (const d of data) {
		const parentId = d[config.parentId]
		if (childrenListMap[parentId] == null) {
			childrenListMap[parentId] = []
		}
		nodeIds[d[config.id]] = d
		childrenListMap[parentId].push(d)
	}

	for (const d of data) {
		const parentId = d[config.parentId]
		if (nodeIds[parentId] == null) {
			tree.push(d)
		}
	}

	for (const t of tree) {
		adaptToChildrenList(t)
	}

	function adaptToChildrenList(o) {
		if (childrenListMap[o[config.id]] !== null) {
			o[config.childrenList] = childrenListMap[o[config.id]] || null
		}
		if (o[config.childrenList]) {
			for (const c of o[config.childrenList]) {
				adaptToChildrenList(c)
			}
		}
	}
	return tree
}

// 树形数组转为一维数组
export function treeDataToCompressed(data) {
	const res = []
	function dulChildren(a) {
		for (const i in a) {
			res.push(a[i])
			a[i].children && a[i].children.length ? dulChildren(a[i].children) : ''
		}
	}

	dulChildren(data)
	return res
}

/**
 * 字符串分割数组方法
 * @param obj
 * @param key
 */
export function splitArray(obj, key) {
	if (obj.hasOwnProperty(key)) {
		// 增加类型判断避免方法报错
		obj[key] = typeof obj[key] === 'string' ? obj[key].split(',') : []
	}
}

/**
 * 数组转换字符串
 * @param obj
 * @param key
 */
export function arrayJoin(obj, key) {
	if (obj.hasOwnProperty(key)) {
		// 增加类型判断避免方法报错
		obj[key] = obj[key] instanceof Array ? obj[key].join(',') : ''
	}
}

/**
 * 从对象数组中获取key值为val的对象
 * @type {*|Function}
 */
export function getObject(arr, key, val) {
	if (arr instanceof Array) {
		let tmp
		for (let i = 0, len = arr.length; i < len; i++) {
			tmp = arr[i]
			if (tmp[key] === val) {
				return tmp
			}
		}
	}
}

/**
 * 将 source 对象中字段值转到 target 对象中指定key中
 * @param source
 * @param target
 */
export function transObject(source, target) {
	for (const key in target) {
		if (source.hasOwnProperty(key)) {
			// 将源数据中属性值为null的转为空字符串
			if (source[key] === null) {
				source[key] = ''
			}

			target[key] = source[key]
		}
		/*if (source.hasOwnProperty(key) && (source[key] || source[key] === 0)) {
      target[key] = source[key]
    }*/
	}
}

/**
 * 获取某个对象的属性值，并进行类型判断
 * @param obj 对象
 * @param propertyName 属性名
 * @returns {string|null}
 */
export function getPropertyValue(obj, propertyName) {
	const value = obj[propertyName]
	return value && typeof value === 'string' && value.trim() !== '' ? value : ''
}

/**
 * 判断对象元素是否存在且有值，并组合成一个结果数组
 * @param source
 * @returns {*[]}
 */
export function pushObjectArrValue(source) {
	const resultArr = []
	for (const key in source) {
		if (source.hasOwnProperty(key) && source[key] !== '' && source[key] !== null) {
			resultArr.push(source[key])
		}
	}
	return resultArr
}

/**
 * 二维数组转字符串
 * @param arr
 * @returns {string}
 */
export function arrToStr(arr) {
	const arrLen = arr.length
	let row = '['
	for (let i = 0; i < arrLen; i++) {
		row += '['
		for (let j = 0; j < arr[i].length; j++) {
			row += "'" + arr[i][j] + "'"
			if (j < arr[i].length - 1) {
				row += ','
			}
		}
		row += ']'
		if (i < arrLen - 1) {
			row += ','
		}
	}
	row += ']'
	return row
}

/**
 * 二维数组转一维数组
 * 也可使用数组扁平化进行处理
 * @param arr
 * @returns {*[]}
 */
export function flatten(arr) {
	return [].concat(...arr.map(item => (Array.isArray(item) ? flatten(item) : item)))
}

/**
 * 判断两个简单数组是否一样（['1', '2', '3']与['1', '2', '3']）
 * @param arr1
 * @param arr2
 * @returns {boolean}
 */
export function arraysAreEqual(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return false
	}
	for (let i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) {
			return false
		}
	}
	return true
}

/**
 * 取出数组对象中所有的子集元素，包含嵌套的children
 * @param arr 目标数组对象
 * @param childKey 子集元素的key
 * @returns {*[]}
 */
export function extractAllChildren(arr, childKey) {
	const result = []

	function traverse(node) {
		if (node[childKey] && node[childKey].length > 0) {
			result.push(...node[childKey])
			node[childKey].forEach(traverse)
		}
	}

	arr.forEach(traverse)
	return result
}

/**
 * 取出数组对象中某一层的子集children
 * @param arr 目标数组对象
 * @param childKey 子集元素的key
 * @param targetLevel 取出第几层，默认第一层
 * @returns {*[]}
 */
export function extractChildrenAtLevel(arr, childKey, targetLevel) {
	const result = []

	function traverse(node, level = 1) {
		if (level === targetLevel && node[childKey] && node[childKey].length > 0) {
			result.push(...node[childKey])
		}
		if (node[childKey] && node[childKey].length > 0) {
			node[childKey].forEach(child => traverse(child, level + 1))
		}
	}

	arr.forEach(child => traverse(child))
	return result
}

/**
 * 数组对象按某个字段进行分组
 * @param arr
 * @param property
 * @returns {*}
 */
export function groupBy(arr, property) {
	return arr.reduce(function(cur, obj) {
		var key = obj[property]
		if (!cur[key]) {
			cur[key] = []
		}
		cur[key].push(obj)
		return cur
	}, {})
}

/**
 * 平替 eval() 方法，将目标值安全的转换为可执行的表达式或者数据类型
 * @param value
 * @returns {string|any}
 */
export function safeEval(value) {
	// 判断目标值是否为有效的非空字符串
	if (typeof value === 'string' && value.trim() !== '') {
		// 将目标字符串的值转换为有效的 JSON 格式（将“'”或者"\""转换为“）
		const jsonString = value.replace(/'|\\"/g, '"').trim()
		try {
			return JSON.parse(jsonString)
		} catch (err) {
			// 解析失败，并保留原值或者设置默认值
			console.log('解析需要转换的目标字符串值失败：', err)
			return value
		}
	} else {
		// 如果不是有效的非空字符串，则直接保留原值或者设置默认值
		return value
	}
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields()
	}
}

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
export const Debounce = (fn, t) => {
	const delay = t || 500
	let timer
	return function() {
		const args = arguments
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			timer = null
			fn.apply(this, args)
		}, delay)
	}
}

/**
 * 文件格式转换：base64转File
 * @param {*} base64
 * @param {*} filename
 * @returns {File} 文件对象
 */
export function base64ToFile(base64, filename = 'chart.png') {
	const arr = base64.split(',')
	const mime = arr[0].match(/:(.*?);/)[1]
	const bytes = atob(arr[1])
	const buffer = new Uint8Array(bytes.length)
	for (let i = 0; i < bytes.length; i++) {
		buffer[i] = bytes.charCodeAt(i)
	}
	return new File([buffer], filename, { type: mime })
}

/**
 * 将element表单校验未通过的元素移动到可视区域
 */
export function scrollElementValidTag() {
	// 获取到表单中所有未校验通过的提示元素
	const isError = document.getElementsByClassName('is-error')
	// 将元素滚动到容器可视区域中
	isError[0].scrollIntoView({
		// 滚动位置，值有：start, center, end, nearest
		block: 'start',
		// 缓动动画，值有：auto,instant,smooth
		behavior: 'smooth'
	})
}

// 验证是否为blob格式
export async function blobValidate(data) {
	try {
		const text = await data.text()
		JSON.parse(text)
		return false
	} catch (error) {
		return true
	}
}
